import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ForwarderGateway } from 'src/app/application/gateway/ForwarderGateway';
import { AssignForwarder, ProfileCompanyList } from 'src/app/domain/models/Company';
import { ForwarderReviewItemList } from 'src/app/domain/models/ForwarderReview';
import { BasicUser } from 'src/app/domain/models/User';
import { Routes } from 'src/app/infrastructure/routes';
@Component({
  selector: 'app-forwarder-user-origin-reviewed',
  templateUrl: './forwarder-user-origin-reviewed.component.html',
  styleUrls: ['./forwarder-user-origin-reviewed.component.css'],
  providers: [ConfirmationService]
})
export class ForwarderUserOriginReviewedComponent implements OnInit {

  tabMenuItems: MenuItem[] = []
  activeItem: MenuItem = {}

  loading: boolean = false
  visibleAssignDialog: boolean = false

  profile: BasicUser | undefined
  reviews: ForwarderReviewItemList[] = []
  forwarders: ProfileCompanyList[] = []
  selectedForwarderOrder: any | undefined
  selectedForwarderGuid: string | undefined

  programOrderOption: string = "Program"
  marketplaceOrderOption: string = "Marketplace"

  constructor(private _router: Router,
    private _messageService: MessageService,
    private _authService: AuthGateway,
    public translate: TranslateService,
    private _forwarderService: ForwarderGateway) {
  }

  ngOnInit(): void {
    this.profile = this._authService.getUser()

    //this.tabMenuItems = [
    //  { label: 'Pending', command: () =>  this._router.navigate(['/'+Routes.forwarderUserReviews]) },
    //  { label: 'Reviewed', command: () =>  this._router.navigate(['/'+Routes.forwarderUserOriginReviewed]) }
    //]

    //this.activeItem = this.tabMenuItems[1]

    this.loadForwarders()
    this.loadOriginReviews()

  }

  ngAfterViewInit(){
    const lang = this.translate.currentLang
    switch(lang) {
      case 'es':
        this.tabMenuItems = [
          { label: 'Pendientes', command: () =>  this._router.navigate(['/'+Routes.forwarderUserReviews]) },
          { label: 'Revisadas', command: () =>  this._router.navigate(['/'+Routes.forwarderUserOriginReviewed]) }
        ]
        break
      case 'en':
        this.tabMenuItems = [
          { label: 'Pending', command: () =>  this._router.navigate(['/'+Routes.forwarderUserReviews]) },
          { label: 'Reviewed', command: () =>  this._router.navigate(['/'+Routes.forwarderUserOriginReviewed]) }
        ]
        break
    }

    this.activeItem = this.tabMenuItems[1]

  }

  loadForwarders() {
    this._forwarderService.getForwardersByAdmin().subscribe({
      next: (v) => {
        this.forwarders = v
      },
      error: (e) => {
        let errorMessage = ''
        const lang = this.translate.currentLang
        switch(lang) {
          case 'es':
            errorMessage = e.error.messageEs
            break
          case 'en':
            errorMessage = e.error.messageEn
            break
          default:
            errorMessage = this.translate.instant('ForwarderPage.Messages.ErrorLoadForwarders')
        }
        console.log(e)
        this._messageService.add({ severity: 'error', summary: this.translate.instant('MessageService.Summary.FailedAction'), detail: errorMessage });
      },
      complete: () =>  {
        this.loading = false
        console.info('Profile query successfully')
      }
    })
  }

  loadOriginReviews() {
    this._forwarderService.getAllByStatusAndReviewType(1).subscribe({
      next: (v) => {
        this.reviews = v.filter(x => x.forwarderDocuments != null && x.forwarderDocuments.length > 0)
        this.loading = false

        const lang = this.translate.currentLang
        switch(lang) {
          case 'es':
            this.programOrderOption = "Programa"
            break
          case 'en':
            this.programOrderOption = "Program"
        }
      },
      error: (e) => {
        let errorMessage = ''
        const lang = this.translate.currentLang
        switch(lang) {
          case 'es':
            errorMessage = e.error.messageEs
            break
          case 'en':
            errorMessage = e.error.messageEn
            break
          default:
            errorMessage = this.translate.instant('ForwarderPage.Messages.ErrorLoadReviews')
        }
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: errorMessage });

        this.loading = false
        console.log(e)
      },
      complete: () =>  {
        this.loading = false
        console.info('Reviews query successfully')
      }
    })
  }

  goToReviewDocuments(review: ForwarderReviewItemList) {
    if(review)
      this._router.navigate(['/' + Routes.forwarderUserOriginReview, review.guid], {queryParams: { navFrom: "reviewed" }})
  }

  goToDelivery(review: ForwarderReviewItemList) {
    if(review)
      this._router.navigate(['/' + Routes.forwarderUsersDelivery, review.importOrderGuid], {queryParams: { navFrom: "reviewed" }})
  }

  openDialog(review: ForwarderReviewItemList) {
    this.selectedForwarderOrder = undefined
    this.selectedForwarderGuid = review.guid
    this.visibleAssignDialog = true
  }

  assignUser() {
    if (this.selectedForwarderOrder && this.selectedForwarderGuid)
    {
      const assignForwarder: AssignForwarder = {
        ForwarderReviewGuid: this.selectedForwarderGuid,
        profileId: this.selectedForwarderOrder
      }
      this._forwarderService.assignForwarder(assignForwarder).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success', summary: this.translate.instant('MessageService.Summary.SuccessAction'), detail: this.translate.instant('ForwarderPage.SuccessAssignForwarder') });
          this.visibleAssignDialog = false
          this.loadOriginReviews()
        },
        error: (e) => {
          let errorMessage = ''
          const lang = this.translate.currentLang
          switch(lang) {
            case 'es':
              errorMessage = e.error.messageEs
              break
            case 'en':
              errorMessage = e.error.messageEn
              break
            default:
              errorMessage = e.error.messageEn
          }
          if(e.status === 500){
            this._messageService.add({ severity: 'error', summary: this.translate.instant('MessageService.Summary.FailedAction'), detail: this.translate.instant('ForwarderPage.ErrorAssignForwarder') })
          }
          else {
            this._messageService.add({ severity: 'error', summary: this.translate.instant('MessageService.Summary.FailedAction'), detail: errorMessage });
          }
          this.loading = false
          console.log(e)
        },
        complete: () =>  {
          this.loading = false
          console.info('Forwarders query successfully')
        }
      })
    }

  }

  getIconUrl(iconUrl: string | undefined): string {
    return iconUrl ? iconUrl : ''
  }

  setVisibleOrderDetail(order: any) {
    if (order) {
      order.expanded = !order.expanded
    }
  }
}
